import Spinner from "../features/shared/components/Spinner"

const Loading = () => {
  return (
    <div className="fixed inset-0 bg-white opacity-100 flex items-center justify-center z-50 h-screen w-screen">
      <Spinner />
    </div>
  )
}

export default Loading
